import { render, staticRenderFns } from "./SaveChanges.vue?vue&type=template&id=3b3f5cc5"
import script from "./SaveChanges.vue?vue&type=script&lang=js"
export * from "./SaveChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports